module.exports = __webpack_public_path__ + "img/icon-edit-pen.0b110c0d.svg";